<template>
  <b-overlay
    :show="show"
    rounded="sm"
    no-fade
  >
    <b-row class="match-height">
      <b-col md="4" v-for="(s, idx) in sites" :key="`ch${idx}`">
        <b-card no-body>
          <b-card-header class="align-items-baseline pb-1">
            <div>
              <b-card-title class="mb-25">
                {{ s.name }}
              </b-card-title>
            </div>
            <b-dropdown
              variant="link"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              right
              no-caret
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="align-right text-body"
                />
              </template>
              <b-dropdown-item @click="edit(s)">
                <feather-icon
                  icon="EditIcon"
                  size="18"
                />
                Edit
              </b-dropdown-item>
              <b-dropdown-item @click="destroy(s.idsite)">
                <feather-icon
                  icon="TrashIcon"
                  size="18"
                />
                Delete
              </b-dropdown-item>
              <b-dropdown-item @click="go_tracking_code(s.idsite)">
                <feather-icon
                  icon="EyeIcon"
                  size="18"
                />
                Tracking Code
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body>
            <div class="d-flex justify-content-between">
              <div class="series-info d-flex align-items-center">
                <feather-icon
                  icon="CircleIcon"
                  size="16"
                  class="text-primary text-danger"
                />
                <span class="font-weight-bold text-capitalize ml-75">URLs</span>
              </div>
              <span class="text-right">{{ s.alias_urls.join(', ') }}</span>
            </div>
            <div class="d-flex justify-content-between">
              <div class="series-info d-flex align-items-center">
                <feather-icon
                  icon="CircleIcon"
                  size="16"
                  class="text-primary text-primary"
                />
                <span class="font-weight-bold text-capitalize ml-75">Timezone</span>
              </div>
              <span>{{ s.timezone }}</span>
            </div>
            <div class="d-flex justify-content-between">
              <div class="series-info d-flex align-items-center">
                <feather-icon
                  icon="CircleIcon"
                  size="16"
                  class="text-primary text-warning"
                />
                <span class="font-weight-bold text-capitalize ml-75">Currency</span>
              </div>
              <span>{{ s.currency }}</span>
            </div>
            <div class="d-flex justify-content-between">
              <div class="series-info d-flex align-items-center">
                <feather-icon
                  icon="CircleIcon"
                  size="16"
                  class="text-primary text-success"
                />
                <span class="font-weight-bold text-capitalize ml-75">Ecommerce</span>
              </div>
              <span>{{ s.ecommerce === '1' ? 'Yes' : 'No' }}</span>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import api from '@/libs/axios'
import { hmAskFor, hmError, hmSuccess } from '@/libs/toastification'
import hmStorage from '@core/utils/hm_storage'

export default {
  data() {
    return {
      sites: [],
      show: false
    }
  },
  methods: {
    getSitesWithAdminAccess() {
      this.show = true
      api.post('/api/matomo/site/with_admin_access')
        .then(r => {
          if (r.data.code !== 'Ok') return hmError('Error reading data')
          this.sites = r.data.sites
        })
        .catch(e => {
          console.error(e)
          hmError('Error reading data')
        })
        .finally(() => {
          this.show = false
        })
    },
    edit(row) {
      hmStorage.setLocalItem('website', row)
      this.$router.push('/all-web-sites/website/update')
    },
    destroy(id) {
      hmAskFor()
        .then(r => {
          if (r.value) {
            api.post('/api/matomo/site/destroy', { id })
              .then(r => {
                if (r.data.code !== 'Ok') return hmError('Error deleting web site')
                hmSuccess('Web site delete successful')
                this.getSitesWithAdminAccess()
              })
              .catch(e => {
                console.error(e)
                hmError('Error deleting web site')
              })
          }
        })
    },
    go_tracking_code(idSite) {
      this.$router.push({
        name: 'measurables-tracking-code',
        query: { idSite }
      })
    }
  },
  mounted() {
    this.getSitesWithAdminAccess()
  }
}
</script>
